import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { useAppDispatch } from "@store/store-helper";
import { setBulkActionName, setInitialFetchingItems } from "@store/table/table-slice";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { Dialog, green, CheckmarkCircleFillIcon, Text } from "@flat-ui";
/** Show success message if all the bulk actions are successful */
export function BulkSuccessDialog(t0) {
  const $ = _c(12);
  const {
    dialogContent
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CheckmarkCircleFillIcon sx={{
      ...getSvgColoredIconCss(green[700]),
      height: "28px",
      width: "28px",
      mr: "12px"
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== dialogContent.title) {
    t3 = <Stack direction="row" sx={t1}>{t2}{dialogContent.title}</Stack>;
    $[2] = dialogContent.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== dispatch) {
    t4 = () => {
      dispatch(setBulkActionName(null));
      dispatch(setInitialFetchingItems([]));
    };
    $[4] = dispatch;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== dialogContent.description) {
    t5 = <Text variant="bodyM">{dialogContent.description}</Text>;
    $[6] = dialogContent.description;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <Dialog open={true} title={t3} onConfirm={t4} confirmText="Done">{t5}</Dialog>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}